module.exports = __webpack_public_path__ + "static/womens-water-polo-gold-medal-group-89cbf35c10bf922ed9920790ec88198e.jpg";